import { render, staticRenderFns } from "./conteudo.vue?vue&type=template&id=09f3e1e6"
import script from "./conteudo.vue?vue&type=script&lang=js"
export * from "./conteudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports